<template>
  <div>
    <DataTable
      :value="records"
      :lazy="true"
      :paginator="true"
      :rows="10"
      ref="dt"
      dataKey="id"
      :totalRecords="totalRecords"
      :loading="loading"
      @page="onPage($event)"
      @filter="onFilter($event)"
      :scrollable="true"
      scrollHeight="500px"
      :rowHover="true"
      showGridLines
      :class="['p-datatable--social-media']"
    >
      <template #empty> No Social Media results found. </template>

      <template #loading> Loading Social Media data. Please wait. </template>

      <Column field="network" header="Network"></Column>

      <Column field="sentiment" header="Sentiment"></Column>

      <Column field="text" header="Text"></Column>

      <Column field="url" header="URL" :style="{ width: '50%' }">
        <template #body="{ data }">
          <a :href="data.url" target="_blank"
            >{{ capitalize(data.network) }} Link</a
          >
        </template>
      </Column>

      <Column header="Social Media Handle">
        <template #body="{ data }">
          <span v-if="data.network == 'twitter'">
            {{
              data.url
                .substring(0, data.url.indexOf("/status"))
                .replace("https://twitter.com/", "@")
            }}
          </span>
          <span v-else-if="data.network == 'youtube'">
            {{ result.post_id }}
          </span>
          <span v-else-if="data.network == 'facebook'">
            {{ data.url.replace("https://business.facebook.com/", "@") }}
          </span>
        </template>
      </Column>
    </DataTable>

    <template v-if="totalRecords > 0">
      <div class="creator-search-results__accordion-copy">
        {{ totalRecords }} Social Media Results Found
      </div>
    </template>
  </div>
</template>
<script setup>
import { ref, defineProps, onMounted } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ApiMixin from "../../mixins/apiMixin";
import { inject } from "vue";

// gettting the correct social media values
const real_twitter = inject("real_twitter");
const real_instagram = inject("real_instagram");
const real_facebook = inject("real_facebook");

// console.log("Twitter value:", real_twitter.value);
// console.log("Instagram value:", real_instagram.value);
// console.log("Facebook value:", real_facebook.value);

// right so we're getting the correct values now we need to pass this through to the paginate to filter.

const props = defineProps(["searchToken"]);

const dt = ref();
const lazyParams = ref({});
const loading = ref(false);
const totalRecords = ref(0);
const records = ref(null);
const capitalize = (s) => (s && s[0].toUpperCase() + s.slice(1)) || "";

onMounted(async () => {
  lazyParams.value = {
    first: 0,
    rows: dt.value.rows,
  };

  // console.log("Component mounted. Initial lazyParams value:", lazyParams.value);
  await loadLazyData();
});

async function onPage(event) {
  lazyParams.value = event;
  // console.log("Page change detected. New lazyParams value:", lazyParams.value);
  await loadLazyData();
}

async function loadLazyData() {
  loading.value = true;
  // console.log("Starting data load. Loading status:", loading.value);
  const result = await ApiMixin.methods.socialUserSearchPaginate(
    props.searchToken,
    lazyParams.value,
    real_twitter.value,
    real_instagram.value,
    real_facebook.value
  );
  // console.log("Data loaded. Raw result:", result);

  // EMPTY RECORD SET OR AN ERROR OCCURRED.
  if (!result) {
    records.value = [];
    totalRecords.value = 0;
    loading.value = false;
    //  console.log(
    //   "No data or error detected. Final records and totalRecords values:",
    //   records.value,
    //   totalRecords.value
    // );
    return false;
  }

  records.value = result.data.results;
  totalRecords.value = result.data.totalRecords;
  loading.value = false;
  // console.log(
  //   "Data processing complete. Final records, totalRecords, and loading values:",
  //   records.value,
  //   totalRecords.value,
  //   loading.value
  // );
}
</script>
